import { useI18n } from "../i18n/I18nContext";

export default function LanguageSwitch({ compact = false }) {
  const { locale, setLocale, t } = useI18n();
  return (
    <div role="group" aria-label={t("language.change")} style={{
      display: "inline-flex", padding: 2, border: "1px solid #343A46",
      borderRadius: 6, background: "#11151C",
    }}>
      {["es", "en"].map((code) => (
        <button key={code} type="button" onClick={() => setLocale(code)}
          aria-pressed={locale === code} data-testid={`language-${code}`}
          style={{
            border: 0, borderRadius: 4, cursor: "pointer",
            padding: compact ? "3px 6px" : "5px 9px", fontSize: 11,
            color: locale === code ? "#fff" : "#8D96A5",
            background: locale === code ? "#3B82F6" : "transparent",
          }}>
          {t(`language.${code}`)}
        </button>
      ))}
    </div>
  );
}
